/**
 * Hook that provides a configured {@link ApiClient} instance for the public
 * leaderboard app. No auth token is needed — all requests go to `/public/*`.
 */

import { useMemo } from 'react';
import { createApiClient } from '@scoring/frontend-shared';
import type { ApiClient } from '@scoring/frontend-shared';

const BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '';

export function usePublicApiClient(): ApiClient {
  return useMemo(
    () =>
      createApiClient({
        baseUrl: BASE_URL,
      }),
    [],
  );
}
